<script>
import GenerationHistorySidebar from './generation-history/GenerationHistorySidebar.vue';

export default GenerationHistorySidebar;
</script>
